module.exports = __webpack_public_path__ + "static/img/video.75710762.png";